import { UsuarioDetailComponent } from './usuarios/usuario-detail/usuario-detail.component';
import { UsuarioListComponent } from './usuarios/usuario-list/usuario-list.component';
import { BreadcrumbsModule } from '@exalif/ngx-breadcrumbs';
import { ResetPasswordComponent } from './passwordRestore/reset-Password/reset-password.component';
import { EqualValidatorDirective } from './core/validators/equal-validator.directive';
import { FileInputValidatorDirective } from './core/validators/file-input-validator.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ForgotPasswordComponent } from './passwordRestore/forgot-Password/forgot-password.component';
import { LoginComponent } from './login/login.component';

import { HomeComponent } from './home/home.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MomentModule } from 'ngx-moment';

/**
 * Font Awesome Icons
 */
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {
  faCashRegister,
  faDolly,
  faTasks,
  faSpinner,
  faBullhorn,
  faUser,
  faUsers,
  faSlidersH,
  faMobileAlt,
  faPencilAlt,
  faIdBadge,
  faComments,
  faLaptop,
  faCommentsDollar,
  faEye,
  faTimes,
  faHandPeace,
  faUserMinus,
  faUserPlus,
  faPercentage,
  faTags,
  faBook,
  faAddressCard,
  faUserFriends,
  faBoxOpen,
  faHandshake,
  faIdCardAlt,
  faChartBar,
  faFileExcel,
  faHeadset,
  faMugHot,
  faChalkboardTeacher,
  faGraduationCap,
  faDatabase,
  faStoreAlt,
  faTag,
  faHome,
  faMoneyBill,
  faComment,
  faQuestion,
  faBookReader,
  faNewspaper,
  faCogs,
  faBuilding,
  faBriefcase,
  faUserCog,
  faUsersCog,
  faCalendar,
  faCalendarAlt,
  faWallet,
  faServer,
  faCog,
  faTerminal,
  faMicrochip,
  faSync,
  faFileInvoiceDollar,
  faPeopleArrows,
  faUserTag,
  faScroll, 
  faEnvelope,
  faCalendarCheck,
  faFileAlt,
  faFileUpload,
  faDownload,
  faArrowAltCircleDown,
  faPaperPlane,
  faToggleOff,
  faToggleOn,
  faPlus,
  faMinus,
  faCheck,
  faSearch,
  faHourglassHalf,
  faDoorOpen,
  faBusinessTime,
  faUserClock,
  faSearchLocation,
  faList,
  faVectorSquare,
  faCalendarPlus,
  faCalendarDay,
  faMapMarker,
  faMapMarkerAlt,
  faFileImport,
  faTrashAlt,
  faTrash,
  faFileDownload,
  faHandPaper,
  faVest,
  faBirthdayCake,
  faStamp,
  faVoteYea,
  faUmbrellaBeach,
  faRing,
  faBaby,
  faBriefcaseMedical,
  faBabyCarriage,
  faHospitalUser,
  faLaughBeam,
  faCertificate
} from '@fortawesome/free-solid-svg-icons';

import { faFileExcel as farFileExcel } from '@fortawesome/free-regular-svg-icons';

import {
  DevExtremeModule,
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxMapModule
} from 'devextreme-angular';

// import 'devextreme-intl';
import { locale, loadMessages } from 'devextreme/localization';
import config from 'devextreme/core/config';

import esMessages from 'devextreme/localization/messages/es.json';

loadMessages(esMessages);
locale(navigator.language);

config({ defaultCurrency: 'EUR' });

import { NgxPermissionsModule } from 'ngx-permissions';
import { NouisliderModule } from 'ng2-nouislider';
import { NgxSmartModalModule } from 'ngx-smart-modal';

import { NgxCurrencyModule } from 'ngx-currency';
import {
  MomentDateAdapter,
  MOMENT_DATE_FORMATS,
} from './core/CustomDataAdapter/MomentDateAdapter';

import localeEs from '@angular/common/locales/es';
import { MaterialModule } from './material/material.module';
import {
  MatNativeDateModule,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { AppConfig } from './core/configuration/app.config';
import { BolsaHorasVacacionesComponent } from './hostelHR/calculoVacaciones/bolsaHorasVacaciones/bolsaHorasVacaciones.component';
registerLocaleData(localeEs);

import { LinkSolucionesIcons } from './core/icons/link-soluciones-icons';
import { MustMatchDirective } from './core/validators/must-match.directive';
import { A3LEmployeesListComponent } from './a3LaboralComponents/Employees/A3LEmployees-List/A3LEmployees-List.component';

import { ContentLoaderModule } from '@ngneat/content-loader';
import { ButtonMenuComponent } from './button-menus/button-menu/button-menu.component';
import { WelcomeDashboardComponent } from './welcome/welcome-dashboard/welcome-dashboard.component';
import { ProcesosListComponent } from './procesos/proceso-list/proceso-list.component';
import { ProcesoDetailComponent } from './procesos/proceso-detail/proceso-detail.component';
import { BolsaVacacionesListComponent } from './hostelHR/bolsaVacaciones/bolsaVacacionesList/BolsaVacacionesList.component';
import { BolsaVacacionesDetailComponent } from './hostelHR/BolsaVacaciones/BolsaVacacionesDetail/BolsaVacacionesDetail.component';
import { GridSolicitudesBolsaVacacionesComponent } from './hostelHR/BolsaVacaciones/grid-solicitudes-bolsa-vacaciones/grid-solicitudes-bolsa-vacaciones.component';
import { PeriodosVacacionesDetailComponent } from './hostelHR/PeriodosVacaciones/periodos-vacaciones-detail/periodos-vacaciones-detail.component';
import { PeriodosVacacionesListComponent } from './hostelHR/PeriodosVacaciones/periodos-vacaciones-list/periodos-vacaciones-list.component';
import { MyCompaniesConfigDetailComponent } from './my-account/my-companies-config-detail/my-companies-config-detail.component';
import { MyCompaniesConfigListComponent } from './my-account/my-companies-config-list/my-companies-config-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { A3LaboralSettingsComponent } from './hostelHR/a3Laboral-settings/a3Laboral-settings.component';
import { ConveniosListComponent } from './hostelHR/convenios/convenios-list/convenios-list.component';
import { LiquidacionesMasivasComponent } from './hostelHR/liquidaciones-masivas/liquidaciones-masivas.component';
import { AsignarTipoCalculoEmpleadoComponent } from './hostelHR/asignar-tipo-calculo-empleado/asignar-tipo-calculo-empleado.component';
import { DiasSolicitadosVsRealesComponent } from './hostelHR/dias-solicitados-vs-reales/dias-solicitados-vs-reales.component';
import { GestionSusticionesBajaListComponent } from './hostelHR/gestion-susticiones-baja/gestion-sustituciones-baja-list/gestion-susticiones-baja-list.component';
import { GestionSustiticionesBajaDetailComponent } from './hostelHR/gestion-susticiones-baja/gestion-sustiticiones-baja-detail/gestion-sustiticiones-baja-detail.component';
import { GestionEmpleadosDetailComponent } from './hostelHR/gestion-empleados/gestion-empleados-detail/gestion-empleados-detail.component';
import { GestionEmpleadosListComponent } from './hostelHR/gestion-empleados/gestion-empleados-list/gestion-empleados-list.component';
import { TramosCodigoEmpleadosComponent } from './hostelHR/tramos-codigo-empleados/tramos-codigo-empleados.component';

//Portal Empleado
import { DropdownFormulariosComponent } from './livesHrComponentes/dropdown-formularios/dropdown-formularios.component';
import { FormInputAppComponent } from './components/form-input-app/form-input-app.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { OrgChartComponent } from './components/org-chart/org-chart.component';
import { RedirectComponent } from './livesHrComponentes/redirect/redirect.component';

import { SolicitudesListComponent } from './livesHrComponentes/solicitudes/solicitudes-list/solicitudes-list.component';
import { AcceptRejectDialogComponent } from './livesHrComponentes/accept-reject-dialog/accept-reject-dialog.component';

import { DocumentosListComponent } from './livesHrComponentes/documentos/documentos-list/documentos-list.component';
import { DocumentosDetailComponent } from './livesHrComponentes/documentos/documentos-detail/documentos-detail.component';
import { DocumentosUsuariosListComponent } from './livesHrComponentes/documentos/documentos-usuarios-list/documentos-usuarios-list.component';
import { DocsUsersDialogComponent } from './livesHrComponentes/docs-users-dialog/docs-users-dialog.component';

import { ConfigEntornoComponent } from './livesHrComponentes/config-entorno/config-entorno.component';
import { EmpresasListComponent } from './livesHrComponentes/empresas/empresas-list/empresas-list.component';
import { EmpresasDetailComponent } from './livesHrComponentes/empresas/empresas-detail/empresas-detail.component';
import { EmpleadosListComponent } from './livesHrComponentes/empleados/empleados-list/empleados-list.component';
import { EmpleadosDetailComponent } from './livesHrComponentes/empleados/empleados-detail/empleados-detail.component';
import { EmpleadosDocumentosListComponent } from './livesHrComponentes/empleados/empleados-documentos-list/empleados-documentos-list.component';
import { UsersDocsDialogComponent } from './livesHrComponentes/users-docs-dialog/users-docs-dialog.component';

import { CustomCompanySelectorComponent } from './livesHrComponentes/custom-company-selector/custom-company-selector.component';
import { SolicitudTimelineComponent } from './livesHrComponentes/solicitud-timeline/solicitud-timeline.component';
import { AnunciosListComponent } from './livesHrComponentes/anuncios/anuncios-list/anuncios-list.component';
import { AnunciosEditDialog } from './livesHrComponentes/anuncios/anuncios-edit-dialog/anuncios-edit-dialog.component';

import { NgxEditorModule } from 'ngx-editor';
import { ChatDetailComponent } from './livesHrComponentes/chat-detail/chat-detail.component';
import { ChatNewDialogComponent } from './livesHrComponentes/chat-new-dialog/chat-new-dialog.component';
import { OnboardingDetailComponent } from './livesHrComponentes/onboarding-detail/onboarding-detail.component';
import { A3DocCloudSettingsComponent } from './livesHrComponentes/a3DocCloud-settings/a3DocCloud-settings.component';
import { ConfigMarcajesListComponent } from './livesHrComponentes/marcajes/config-marcajes-list/config-marcajes-list.component';
import { ConfigMarcajesDialog } from './livesHrComponentes/marcajes/config-marcajes-dialog/config-marcajes-dialog.component';
import { EditCentrosDialog } from './livesHrComponentes/marcajes/edit-centros-dialog/edit-centros-dialog.component';
import { EditTiposDialog } from './livesHrComponentes/marcajes/edit-tipos-dialog/edit-tipos-dialog.component';
import { MarcajesListComponent } from './livesHrComponentes/marcajes/marcajes-list/marcajes-list.component';
import { EditMarcajesDialog } from './livesHrComponentes/marcajes/edit-marcajes-dialog/edit-marcajes-dialog.component';
import { EditMarcajesSummaryDialog } from './livesHrComponentes/marcajes/edit-marcajes-summary-dialog/edit-marcajes-summary-dialog.component';
import { MarcajeCoordinatesDialog } from './livesHrComponentes/marcajes/marcaje-coordinates-dialog/marcaje-coordinates-dialog.component';
import { MarcajeExportDialog } from './livesHrComponentes/marcajes/marcaje-export-dialog/marcaje-export-dialog.component';
import { ImportarExcelDialog } from './livesHrComponentes/importar-excel-dialog/importar-excel-dialog.component';
import { CalendarioComponent } from './livesHrComponentes/calendario/calendario.component';

import { AppSecurityService } from './core/services/appSecurity.service';
import { CustomMapComponent } from './livesHrComponentes/custom-map/custom-map.component';



export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: ' €',
  thousands: '.',
  nullable: true,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    BolsaVacacionesListComponent,
    BolsaVacacionesDetailComponent,
    UsuarioListComponent,
    UsuarioDetailComponent,
    EqualValidatorDirective,
    FileInputValidatorDirective,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    A3LEmployeesListComponent,
    MustMatchDirective,
    ButtonMenuComponent,
    WelcomeDashboardComponent,
    ProcesoDetailComponent,
    ProcesosListComponent,
    BolsaHorasVacacionesComponent,
    GridSolicitudesBolsaVacacionesComponent,
    PeriodosVacacionesDetailComponent,
    PeriodosVacacionesListComponent,
    MyCompaniesConfigDetailComponent,
    MyCompaniesConfigListComponent,
    A3LaboralSettingsComponent,
    ConveniosListComponent,
    LiquidacionesMasivasComponent,
    GestionSusticionesBajaListComponent,
    GestionSustiticionesBajaDetailComponent,
    AsignarTipoCalculoEmpleadoComponent,
    DiasSolicitadosVsRealesComponent,
    GestionEmpleadosDetailComponent,
    GestionEmpleadosListComponent,
    TramosCodigoEmpleadosComponent,
    DropdownFormulariosComponent,
    FormInputAppComponent,
    ImageViewerComponent,
    ImageUploaderComponent,
    OrgChartComponent,
    RedirectComponent,
    SolicitudesListComponent,
    AcceptRejectDialogComponent,
    DocumentosListComponent,
    DocumentosDetailComponent,
    DocumentosUsuariosListComponent,
    DocsUsersDialogComponent,
    ConfigEntornoComponent,
    EmpresasListComponent,
    EmpresasDetailComponent,
    EmpleadosListComponent,
    EmpleadosDetailComponent,
    EmpleadosDocumentosListComponent,
    UsersDocsDialogComponent,
    CustomCompanySelectorComponent,
    SolicitudTimelineComponent,
    AnunciosListComponent,
    AnunciosEditDialog,
    ChatDetailComponent,
    ChatNewDialogComponent,
    OnboardingDetailComponent,
    A3DocCloudSettingsComponent,
    ConfigMarcajesListComponent,
    ConfigMarcajesDialog,
    EditTiposDialog,
    EditCentrosDialog,
    MarcajesListComponent,
    EditMarcajesDialog,
    EditMarcajesSummaryDialog,
    MarcajeCoordinatesDialog,
    MarcajeExportDialog,
    ImportarExcelDialog,
    CalendarioComponent,
    CustomMapComponent

  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    CoreModule,
    DxDataGridModule,
    DevExtremeModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    NgxPermissionsModule.forRoot(),
    BreadcrumbsModule.forRoot(),
    NgxSmartModalModule.forRoot(),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NouisliderModule,
    MaterialModule,
    MatNativeDateModule,
    BrowserAnimationsModule,
    MomentModule,
    ContentLoaderModule,
    FontAwesomeModule,
    NgbModule,
    // CalendarModule.forRoot({ provide: DateAdapter, useFactory: momentAdapterFactory })
    NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Negrita',
        italic: 'Cursiva',
        code: 'Código',
        blockquote: 'Cita',
        underline: 'Subrayado',
        strike: 'Tachado',
        bullet_list: 'Lista',
        ordered_list: 'Lista Ordenada',
        heading: 'Encabezado',
        h1: 'Título 1',
        h2: 'Título 2',
        h3: 'Título 3',
        h4: 'Título 4',
        h5: 'Título 5',
        h6: 'Título 6',
        align_left: 'Alineado Izquierda',
        align_center: 'Alineado Centro',
        align_right: 'Alineado Derecha',
        align_justify: 'Justificar',
        text_color: 'Color de Texto',
        background_color: 'Color de Fondo',
        link: 'Enlace',
        image: 'Insertar Imagen',
        url: 'URL',
        text: 'Texto',        
        openInNewTab: 'Abrir en nueva pestaña',
        insert: 'Insertar',
        altText: 'Texto de imagen',
        title: 'Título',
        remove: 'Eliminar',
      },
    }),
    DxMapModule,
  ],
  exports: [FormsModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    // { provide: DateAdapter, useClass: MomentDateAdapter },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    AppSecurityService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faCashRegister);
    library.addIcons(faDolly);
    library.addIcons(faTasks);
    library.addIcons(faSpinner);
    library.addIcons(faBullhorn);
    library.addIcons(faUser);
    library.addIcons(faUsers);
    library.addIcons(faSlidersH);
    library.addIcons(faMobileAlt);
    library.addIcons(faPencilAlt);
    library.addIcons(faIdBadge);
    library.addIcons(faComments);
    library.addIcons(faLaptop);
    library.addIcons(faCommentsDollar);
    library.addIcons(faEye);
    library.addIcons(faTimes);
    library.addIcons(faUserMinus);
    library.addIcons(faUserPlus);
    library.addIcons(faHandPeace);
    library.addIcons(faPercentage);
    library.addIcons(faTags);
    library.addIcons(faBook);
    library.addIcons(faAddressCard);
    library.addIcons(faUserFriends);
    library.addIcons(faBoxOpen);
    library.addIcons(faHandshake);
    library.addIcons(faIdCardAlt);
    library.addIcons(faChartBar);
    library.addIcons(faTasks);
    library.addIcons(farFileExcel);
    library.addIcons(faFileExcel);
    library.addIcons(faHeadset);
    library.addIcons(faMugHot);
    library.addIcons(faChalkboardTeacher);
    library.addIcons(faGraduationCap);
    library.addIcons(faDatabase);
    library.addIcons(faStoreAlt);
    library.addIcons(faTag);
    library.addIcons(faMoneyBill);
    library.addIcons(faTimes);
    library.addIcons(faCheck);
    library.addIcons(faMinus);
    library.addIcons(faQuestion);
    library.addIcons(faComment);
    library.addIcons(faHome);
    library.addIcons(faBookReader);
    library.addIcons(faNewspaper);
    library.addIcons(faGraduationCap);
    library.addIcons(faCogs);
    library.addIcons(faCalendar);
    library.addIcons(faBuilding);
    library.addIcons(faBriefcase);
    library.addIcons(faUsersCog);
    library.addIcons(faUserCog);
    library.addIcons(faTag);
    library.addIcons(faWallet);
    library.addIcons(faCalendarAlt);
    library.addIcons(LinkSolucionesIcons.faSmartCrmIcon);
    library.addIcons(faServer);
    library.addIcons(faCog);
    library.addIcons(faTerminal);
    library.addIcons(faMicrochip);
    library.addIcons(faSync);
    library.addIcons(faFileInvoiceDollar);
    library.addIcons(faPeopleArrows);
    library.addIcons(faUserTag);
    library.addIcons(faScroll);
    library.addIcons(faEnvelope);
    library.addIcons(faCalendarCheck);
    library.addIcons(faFileAlt);
    library.addIcons(faFileUpload);
    library.addIcons(faDownload);
    library.addIcons(faArrowAltCircleDown);
    library.addIcons(faPaperPlane);
    library.addIcons(faToggleOff);
    library.addIcons(faToggleOn);
    library.addIcons(faSearch);
    library.addIcons(faHourglassHalf);
    library.addIcons(faDoorOpen);
    library.addIcons(faPlus);
    library.addIcons(faBusinessTime);
    library.addIcons(faUserClock);
    library.addIcons(faSearchLocation);
    library.addIcons(faList);
    library.addIcons(faVectorSquare);
    library.addIcons(faCalendarPlus);
    library.addIcons(faCalendarDay);
    library.addIcons(faMapMarker);
    library.addIcons(faMapMarkerAlt);
    library.addIcons(faFileImport);
    library.addIcons(faFileDownload);
    library.addIcons(faTrash);
    library.addIcons(faHandPaper);
    library.addIcons(faBirthdayCake);
    library.addIcons(faStamp);
    library.addIcons(faVoteYea);
    library.addIcons(faUmbrellaBeach);
    library.addIcons(faRing);
    library.addIcons(faBaby);
    library.addIcons(faBriefcaseMedical);
    library.addIcons(faBabyCarriage);
    library.addIcons(faHospitalUser);
    library.addIcons(faLaughBeam);
    library.addIcons(faCertificate);
    library.addIcons(faBirthdayCake);

    library.addIcons(LinkSolucionesIcons.klikticket);
    library.addIcons(LinkSolucionesIcons.myReportIn);
    library.addIcons(LinkSolucionesIcons.hostelHRIcon);
  }
}

export function initializeApp(appConfig: AppConfig): () => Promise<void> {
  return () => appConfig.load();
}